import { atom } from "recoil";
import { ProfileIterface } from "../pages/Profile/modal/ProfileModal";

export const profileAtom = atom<ProfileIterface>({
    default: undefined,
    key: 'profileAtom'
  })

